import { setLocale } from 'yup';

setLocale({
  mixed: {
    required: () => ({
      key: 'field_is_required',
    }),
    notType: () => ({ key: 'txt_invalid_date' }),
  },
  string: {
    max: ({ max }) => ({
      key: `field_max_length_${max}`,
      values: { max },
    }),
    min: ({ min }) => ({ key: `field_min_length_${min}`, values: { min } }),
    email: () => ({
      key: 'email_is_invalid',
    }),
    matches: () => ({
      key: 'password_invalid_format',
    }),
  },
  date: {
    min: ({ min }) => ({ key: 'date_min', values: { min } }),
    max: ({ max }) => ({ key: 'date_max', values: { max } }),
  },
  number: {
    min: ({ min }) => ({
      key: 'field_min_value',
      values: { min },
    }),
    positive: () => ({
      key: 'field_must_be_positive',
    }),
  },
  array: {
    min: ({ min }) => ({
      key: 'array_min_items',
      values: { min },
    }),
    max: ({ max }) => ({
      key: 'array_max_items',
      values: { max },
    }),
  },
});
